import { memo, useCallback } from 'react';

import * as PageProductStore from '@Stores/PageProduct';
import * as ModalWindows from '@Stores/ModalWindows';
import useTranslation from '@Queries/useTranslation';
import Button from '@UI/Button';

import type { ButtonProps } from '@UI/Button';
import type { FC } from 'react';

export interface PreorderButtonProps extends ButtonProps {
  className: string;
}

const PreorderButton: FC<PreorderButtonProps> = (props) => {
  const page = PageProductStore.useData();
  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    ModalWindows.open('Preorder', {
      product: page.product,
    });
  }, [page.product]);

  return (
    <Button {...props} wide data-testid='sidebar-buy-button' onClick={handleClick}>
      {t('preorder')}
    </Button>
  );
};

export default memo(PreorderButton);
